
const Title= () => {
    return(
        <div className="title-bg">
            <div className="title-block">
                    <h1>Hello, I am your best friend!</h1>
                    <p>I've lost my house due to russian invasion of Ukraine. Please, don't left me along! </p>
            </div>
        </div>
    )
}

export default Title;
